module.exports = __webpack_public_path__ + "img/9788958283799.a689f9d8.jpg";